import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'address2coordinates',
    name: 'Address2Coordinates',
    description: 'projects.items.address2coordinates.description',
    language: 'go',
    github: 'https://github.com/sudekunduroglu/Address2Coordinates',
    tags: ['Go', 'REST API', 'Microservice'],
  },
  {
    id: 'esp32-zephyr',
    name: 'ESP32-Zephyr-Projects',
    description: 'projects.items.esp32-zephyr.description',
    language: 'c',
    github: 'https://github.com/sudekunduroglu/ESP32-Zephyr-Projects',
    tags: ['C', 'Zephyr', 'ESP32', 'RTOS'],
  },
  {
    id: 'esp32-scanner',
    name: 'ESP32-Network-Scanner',
    description: 'projects.items.esp32-scanner.description',
    language: 'c',
    github: 'https://github.com/sudekunduroglu/ESP32-Network-Scanner',
    tags: ['C', 'ESP32', 'Networking', 'ARP'],
  },
  {
    id: 'nfc-wallet',
    name: 'NFC_Wallet_Project',
    description: 'projects.items.nfc-wallet.description',
    language: 'cpp',
    github: 'https://github.com/sudekunduroglu/NFC_Wallet_Project',
    tags: ['C++', 'NFC', 'PN532', 'Embedded'],
  },
  {
    id: 'nrf-zephyr',
    name: 'nRF-Zephyr-Projects',
    description: 'projects.items.nrf-zephyr.description',
    language: 'c',
    github: 'https://github.com/sudekunduroglu/nRF-Zephyr-Projects',
    tags: ['C', 'Zephyr', 'nRF52840', 'BLE'],
  },
  {
    id: 'reverse-engineering',
    name: 'Reverse-Engineering',
    description: 'projects.items.reverse-engineering.description',
    language: 'assembly',
    github: 'https://github.com/sudekunduroglu/Reverse-Engineering',
    tags: ['Assembly', 'x86', 'ARM', 'Security'],
  },
  {
    id: 'deysis-tui',
    name: 'deysis-tui',
    description: 'projects.items.deysis-tui.description',
    language: 'rust',
    github: 'https://github.com/sudekunduroglu/deysis-tui',
    tags: ['Rust', 'TUI', 'Terminal'],
  },
  {
    id: 'snake-ai',
    name: 'Snake_AI',
    description: 'projects.items.snake-ai.description',
    language: 'python',
    github: 'https://github.com/sudekunduroglu/Snake_AI',
    tags: ['Python', 'AI', 'Pathfinding'],
  },
  {
    id: 'deuzone',
    name: 'DEUZONE',
    description: 'projects.items.deuzone.description',
    language: 'go',
    github: 'https://github.com/sudekunduroglu/DEUZONE',
    tags: ['Go', 'Web', 'E-commerce'],
  },
  {
    id: 'hacking-windows',
    name: 'Hacking-Windows',
    description: 'projects.items.hacking-windows.description',
    language: 'c',
    github: 'https://github.com/sudekunduroglu/Hacking-Windows',
    tags: ['C', 'Win32', 'Windows', 'Internals'],
  },
];
